function createLinkMore() {
  const more = document.createElement('span');
  more.textContent =
    document.documentElement.lang === 'pl' ? 'Zobacz więcej' : 'See more';
  more.classList.add('o-link');

  return more;
}

function collapse(children, link) {
  children.forEach(item => {
    item.classList.remove('u-hidden');
  });

  link.remove();
}

function truncate(text) {
  const { children } = text;

  [...children].forEach((item, index) => {
    if (index > 1) {
      item.classList.add('u-hidden');
    } else if (index === 1) {
      const link = createLinkMore();
      item.appendChild(link);
      link.addEventListener('click', () => collapse([...children], link));
    }
  });
}

const truncateText = () => {
  const texts = document.querySelectorAll('.js-truncate-text');

  if (texts.length !== 0) {
    texts.forEach(text => {
      truncate(text);
    });
  }
};

export default truncateText;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/truncate-text.js